module.exports = __webpack_public_path__ + "img/Logo_solo.17833d7b.png";